<div class="container" [ngStyle]="{ 'visibility': playerVisibility}">
  <div id="player-{{index}}" #video [ngStyle]="{'width.px': sizes.width, 'height.px': sizes.height}"></div>
  <div [ngClass]="{ overlay: isShowOverlay(), 'empty-overlay': !multiviewEntity?.url}">
    <div class="info">
      <div *ngIf="gridOverlays?.streamName" class="name">
        <span>{{title}}</span>
      </div>
      <app-copy-link *ngIf="gridOverlays?.sourceAddress && multiviewEntity?.streamUrl"
                     iconPosition="none"
                     [value]="multiviewEntity.streamUrl"
                     [enableEllipsis]="true"
      ></app-copy-link>
      <div class="empty-input" *ngIf="isShowNotConfiguredMessage()">
        Input is not configured
      </div>
    </div>
  </div>

  <!-- Mute/ Unmute / Sound level icon -->
  <div class="sound-icon"
       *ngIf="isDisplaySoundIcon && !isUseNativeControls && this.isConnected "
       (click)="toggleSound()"
       (mouseenter)="onMouseEnter()"
       (mouseleave)="onMouseLeave()"
  >
    <mat-icon color="primary" *ngIf="!isMuted">volume_up</mat-icon>
    <mat-icon color="primary" *ngIf="isMuted">volume_off</mat-icon>
  </div>

  <div class="bitrate" *ngIf="gridOverlays?.bitrate && currentStream?.bandwidth && multiviewEntity.url">
    {{formatBitrate()}} kb/s
  </div>

  <div class="expand"
       *ngIf="isDisplayExpandIcon && this.isConnected"
       (click)="onExpand()"
  >
    <mat-icon color="primary">crop_free</mat-icon>
  </div>

  <div *ngIf="gridOverlays?.vuMeter && isEnabledVU">
    <div *ngFor="let item of VUIndicatorQty; let i = index">
      <app-sldp-player-vu-indicator [VUValues]="VUUpdatedValues"
                                    [VUHeight]="VUHeight"
                                    [index]="i"></app-sldp-player-vu-indicator>
    </div>
  </div>

  <div class="sound-slider"
       (mouseenter)="onMouseEnter()"
       (mouseleave)="onMouseLeave()"
       *ngIf="!isUseNativeControls" [ngStyle]="{ 'visibility': isShowSoundSlider ? 'visible' : 'hidden'}">
    <app-volume-slider [volume]="volume" (onVolumeChange)=onChangeVolume($event)></app-volume-slider>
  </div>
</div>
